import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

interface IAddDocumentInterventionSuccessAction {
  document: {
    created_at: string;
    document_id: number;
    document_url: string;
    file_name: string;
    file_type: string;
    id: number;
    intervention_id: string;
    mime_type: string;
    temporary_url: string;
  };
}
const invoiceTypes = ['document_invoice', 'insurer', 'document_quote'];
const mandateTypes = ['document_mandate'];
const reportTypes = ['report'];

function addDocumentSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IAddDocumentInterventionSuccessAction>,
) {
  draft.addDocument.config.isLoading = false;
  if (action.payload.document.file_type === 'photo_post_repair') {
    draft.getDocuments.documents.photosRepair =
      draft.getDocuments.documents.photosRepair?.concat([
        action.payload.document,
      ]);
  } else if (action.payload.document.file_type === 'photo_damage') {
    draft.getDocuments.documents.photosDamage =
      draft.getDocuments.documents.photosDamage?.concat([
        action.payload.document,
      ]);
  } else if (reportTypes.includes(action.payload.document.file_type)) {
    draft.getDocuments.documents.report =
      draft.getDocuments.documents.report?.concat([action.payload.document]);
  } else if (mandateTypes.includes(action.payload.document.file_type)) {
    draft.getDocuments.documents.mandate =
      draft.getDocuments.documents.mandate?.concat([action.payload.document]);
  } else if (invoiceTypes.includes(action.payload.document.file_type)) {
    draft.getDocuments.documents.invoice =
      draft.getDocuments.documents.invoice?.concat([action.payload.document]);
  }
}

export default addDocumentSuccess;
